<div class="titanInformation">
  <!-- TitanCard -->
  <div class="titanCard">
      <div class="flexCard">
          <div class="titanIMG">
              <img src="{{ titanImageURL }}">
          </div>
          <div class="titanText">
              <h4>{{titanName}}</h4>
              <div class="ubication">
                  <mat-icon> location_on</mat-icon> <p>{{titanLocation}}</p>
              </div>
              <p>Habla con {{titanName}} para recibir recomendaciones y ser parte de sus circulo de confianza</p>
              <button class="contactButton">
                  <svg xmlns="http://www.w3.org/2000/svg" width="20px" viewBox="0 0 24 24"><path fill="currentColor" d="M12.04 2c-5.46 0-9.91 4.45-9.91 9.91c0 1.75.46 3.45 1.32 4.95L2.05 22l5.25-1.38c1.45.79 3.08 1.21 4.74 1.21c5.46 0 9.91-4.45 9.91-9.91c0-2.65-1.03-5.14-2.9-7.01A9.816 9.816 0 0 0 12.04 2m.01 1.67c2.2 0 4.26.86 5.82 2.42a8.225 8.225 0 0 1 2.41 5.83c0 4.54-3.7 8.23-8.24 8.23c-1.48 0-2.93-.39-4.19-1.15l-.3-.17l-3.12.82l.83-3.04l-.2-.32a8.188 8.188 0 0 1-1.26-4.38c.01-4.54 3.7-8.24 8.25-8.24M8.53 7.33c-.16 0-.43.06-.66.31c-.22.25-.87.86-.87 2.07c0 1.22.89 2.39 1 2.56c.14.17 1.76 2.67 4.25 3.73c.59.27 1.05.42 1.41.53c.59.19 1.13.16 1.56.1c.48-.07 1.46-.6 1.67-1.18c.21-.58.21-1.07.15-1.18c-.07-.1-.23-.16-.48-.27c-.25-.14-1.47-.74-1.69-.82c-.23-.08-.37-.12-.56.12c-.16.25-.64.81-.78.97c-.15.17-.29.19-.53.07c-.26-.13-1.06-.39-2-1.23c-.74-.66-1.23-1.47-1.38-1.72c-.12-.24-.01-.39.11-.5c.11-.11.27-.29.37-.44c.13-.14.17-.25.25-.41c.08-.17.04-.31-.02-.43c-.06-.11-.56-1.35-.77-1.84c-.2-.48-.4-.42-.56-.43c-.14 0-.3-.01-.47-.01"/></svg>
                  CONTACTAR AL TITÁN
              </button>                  
          </div>
      </div>
      <div class="endInformation">
          <p><span class="pacts">{{pactsNumber}}</span>Pactos</p>
          <p>|</p>
          <p><span class="bold">ID:</span>{{titanID}}</p>
          <p>|</p>
          <p><span class="bold">{{titanSelections}}</span> Selecciones del titán</p>
      </div>
  </div>
</div>
<!-- Carrusel de Godzillas -->
<div class="sectionCarrusel">
  <div class="godzillasCarrousel">
    <h4>Recomendaciones de confianza</h4>
    <div class="carrusel-controls">
      <button class="prev-button" (click)="showPrev()" [style.visibility]="currentIndex === 0 ? 'hidden' : 'visible'">&#10132;</button>
      <div class="carrusel-viewport">
        <div class="carrusel-container">
          <ng-container *ngFor="let image of images; let i = index">
              <mat-card *ngIf="i >= currentIndex && i < currentIndex + visibleItems" class="image-card">
                  <a [href]="image.href" target="_blank">
                      <img mat-card-image class="carrusel-image" [src]="image.src" alt="Carrusel imagen" *ngIf="image.src !== ''">
                  </a>
              </mat-card>
          </ng-container>
      </div>        
      </div>      
      <button (click)="showNext()" [style.visibility]="currentIndex >= images.length - 4 ? 'hidden' : 'visible'" class="next-button">&#10132;</button>
    </div>    
  <div class="dots-container">
      <ng-container *ngFor="let image of images.slice(0, images.length - 3); let i = index">
          <mat-icon class="dot" [ngClass]="{ 'active-dot': i === currentIndex }" (click)="changeSlide(i)">&#8226;</mat-icon>
      </ng-container>
    </div>                
</div>
</div>
<div class="sectionSelection">
<div class="titanSelection">
  <h4>Selecciones del titán</h4>
  <div class="globalFilters">
    <h5>Filtrar por Temas</h5>
    <div class="cardFilters">
      <div *ngFor="let id of idsUnicos">
        <button class="btn filterButton" [ngClass]="{'filterButton-selected': filtroActual.includes(id)}" (click)="filtrarProductos(id)">
          {{ id }}
        </button>             
      </div>
    </div> 
    <div class="deleteFilters">
      <button class="buttonDelete" (click)="eliminarFiltros()">Eliminar filtros</button>
    </div>      
  </div>   
</div>
</div>

<div class="sectionCardsServices">
<div class="containerCards">
  <div class="card-deck">
    <div class="card" *ngFor="let producto of paginatedProductos">
      <img class="card-img-top" [src]="producto.imagen" alt="Imagen del producto">
      <div class="card-body">
        <h5 class="card-title">{{ producto.titulo }}</h5>
        <p class="card-text">{{ producto.descripcion }}</p>
        <button class="bodyCardButton">Más información</button>
      </div>
    </div>
  </div>
</div>
</div>

<div class="pagination-controles">
<button (click)="previousPage()" [disabled]="currentPage === 0">&lt;</button>

<ng-container *ngFor="let page of [].constructor(totalPages); let i = index">
  <button (click)="goToPage(i)" [class.active]="i === currentPage" [class.page-btn]="true">{{ i + 1 }}</button>
</ng-container>

<button (click)="nextPage()" [disabled]="currentPage >= totalPages - 1">&gt;</button>
</div>

<div class="CatalogButton">
<button class="CatalogBTN">Descargar catálogo</button>
</div>







